import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import CustomTypography from '../custom-material/typography/Typography'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import { TitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import { isEmpty } from 'lodash'
import { toTitleCase } from '../../libs/utils'
import settings from '../../libs/settings'
import Button from '@material-ui/core/Button'
import LoadingComponent from '../common/loading/LoadingComponent'

const styles = theme => ({
  card: {
    height: '100%',
    marginRight: 16
  },
  cardHeader: {
    backgroundColor: '#E1ECF8',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16
  },
  cardHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cardTitleText: {
    color: 'black',
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: 22,
    lineHeight: 1.35
  },
  cardContent: {
    maxHeight: 600,
    overflowY: 'auto',
    padding: '16px !important'
  },
  allEmailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  expansionPanelSummaryContainer: {
    backgroundColor: '#1A2F5A',
    borderTop: '1px solid #C0C0C0',
    borderBottom: '1px solid #003368',
    paddingLeft: 12,
    paddingRight: 12,
    height: '50px !important',
    minHeight: '50px !important'
  },
  expansionPanelSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    color: 'white',
    fontSize: 15,
    margin: '0 !important',
    '& :last-child': {
      paddingRight: 0,
      marginRight: 16
    }
  },
  innerExpansionPanelSummaryContainer: {
    backgroundColor: '#D4D4D3',
    borderTop: '1px solid #C0C0C0',
    borderBottom: '1px solid #003368',
    paddingLeft: 12,
    paddingRight: 12,
    height: '50px !important',
    minHeight: '50px !important'
  },
  innerExpansionPanelSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    color: 'black',
    fontSize: 15,
    margin: '0 !important',
    '& :last-child': {
      paddingRight: 0,
      marginRight: 16
    }
  },
  expandIcon: {
    position: 'absolute',
    right: 10,
    color: 'white'
  },
  manageFavoritesButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 8,
    textDecoration: 'none',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 0
  },
  manageFavoritesIcon: {
    color: '#1A2F5A'
  },
  drugContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 8,
    borderBottom: '1px solid #C0C0C0'
  },
  drugRegions: {
    marginTop: 2,
    fontSize: 12
  },
  link: {
    color: '#1A2F5A'
  },
  collapseContainer: {
    transition: 'none'
  },
  expansionPanelOuter: {
    margin: '0px 0px 16px 0px !important'
  },
  expansionPanelInner: {
    margin: '0px !important'
  }
})

class PublicationDrugTopicsCard extends React.PureComponent {
  constructor () {
    super()

    this.fetchFilterResults = filterIndex => (event, expanded) => {
      if (!expanded) return
      if (this.props.loadingFilterResults.includes(filterIndex)) return
      if (this.props.emailPreferences.filterResults.filters[filterIndex]) return

      this.props.fetchFilterResults(filterIndex)
    }
  }

  render () {
    const { classes, emailPreferences, hasFavorites, managingOther, loadingFilterResults } = this.props

    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{root: classes.cardHeader, content: classes.cardHeaderContent}}
          title={<CustomTypography className={classes.cardTitleText} variant='h6'>Your Publication<br />Drug Topics</CustomTypography>}
        />
        <CardContent className={classes.cardContent}>
          <div className={classes.allEmailsContainer}>
            {hasFavorites && <CustomExpansionPanel defaultExpanded classes={{ root: classes.expansionPanelOuter }} TransitionProps={{classes: {root: classes.collapseContainer}}}>
              <TitleCustomExpansionPanelSummary
                classes={{
                  root: classes.expansionPanelSummaryContainer,
                  content: classes.expansionPanelSummary,
                  expandIcon: classes.expandIcon
                }}
                expandIcon={<ArrowRightIcon style={{fontSize: 35, color: 'white'}} />}
              >
                <span>Favorites</span>
              </TitleCustomExpansionPanelSummary>
              <CustomExpansionPanelDetails style={{padding: 0}}>
                <React.Fragment>
                  {!managingOther && <Button
                    fullWidth
                    variant='contained'
                    color='default'
                    className={classes.manageFavoritesButton}
                    href={`${settings.API_IPD_ROUTE_USER}/Pharma/Favorite`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Manage Favorites
                    <ExitToAppIcon className={classes.manageFavoritesIcon} />
                  </Button>}
                  {isEmpty(emailPreferences) || isEmpty(emailPreferences.filterResults) || isEmpty(emailPreferences.filterResults.favorites)
                    ? <span className={classes.drugContainer}>No favorites found.</span>
                    : emailPreferences.filterResults.favorites.map((drug, drugIndex) => (
                      <div key={drugIndex} className={classes.drugContainer}>
                        <span className={classes.drugName}>{drug.name}</span>
                        <span className={classes.drugRegions}>{(drug.regions.map(x => x === 'EP' ? 'EU' : x) || []).join('; ')}</span>
                      </div>
                    ))
                  }
                </React.Fragment>
              </CustomExpansionPanelDetails>
            </CustomExpansionPanel>}
            <CustomExpansionPanel defaultExpanded classes={{ root: classes.expansionPanelOuter }} TransitionProps={{classes: {root: classes.collapseContainer}}}>
              <TitleCustomExpansionPanelSummary
                classes={{
                  root: classes.expansionPanelSummaryContainer,
                  content: classes.expansionPanelSummary,
                  expandIcon: classes.expandIcon
                }}
                expandIcon={<ArrowRightIcon style={{fontSize: 35, color: 'white'}} />}
              >
                <span>Customized Email Topics</span>
              </TitleCustomExpansionPanelSummary>
              <CustomExpansionPanelDetails style={{padding: 0}}>
                {isEmpty(emailPreferences) || isEmpty(emailPreferences.preferences)
                  ? <span className={classes.drugContainer}>No customized email topics found.</span>
                  : emailPreferences.preferences.filter(x => x.name).map((preference, filterIndex) => (
                    <CustomExpansionPanel key={filterIndex} classes={{ root: classes.expansionPanelInner }} TransitionProps={{classes: {root: classes.collapseContainer}}}
                      onChange={this.fetchFilterResults(filterIndex)}>
                      <TitleCustomExpansionPanelSummary
                        classes={{
                          root: classes.innerExpansionPanelSummaryContainer,
                          content: classes.innerExpansionPanelSummary,
                          expandIcon: classes.expandIcon
                        }}
                        expandIcon={<ArrowRightIcon style={{fontSize: 35, color: '#1A2F5A'}} />}
                      >
                        <span>{preference.name}</span>
                      </TitleCustomExpansionPanelSummary>
                      <CustomExpansionPanelDetails style={{padding: 0}}>
                        {isEmpty(emailPreferences.filterResults.filters[filterIndex]) || isEmpty(emailPreferences.filterResults.filters[filterIndex].values)
                            ? <span className={classes.drugContainer}>
                              {preference.active ? loadingFilterResults.includes(filterIndex) ? <LoadingComponent /> : `No drug topics matched this filter.` : `${preference.name} is not active.`}
                            </span>
                            : emailPreferences.filterResults.filters[filterIndex].values.map((drug, drugIndex) => (
                              <div key={drugIndex} className={classes.drugContainer}>
                                {drug.hasLink
                                ? <a
                                  className={classes.link}
                                  href={`${settings.API_IPD_ROUTE_USER}/Pharma/Drug/${drug.id}`}
                                  target='_blank'
                                  rel='noopener noreferrer'>
                                  {toTitleCase(drug.name)}
                                </a>
                                : toTitleCase(drug.name)}
                              </div>
                            ))
                        }
                      </CustomExpansionPanelDetails>
                    </CustomExpansionPanel>
                  ))
                }
              </CustomExpansionPanelDetails>
            </CustomExpansionPanel>
          </div>
        </CardContent>
      </Card>
    )
  }
}

PublicationDrugTopicsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  emailPreferences: PropTypes.object,
  hasFavorites: PropTypes.bool.isRequired,
  managingOther: PropTypes.bool.isRequired,
  loadingFilterResults: PropTypes.arrayOf(PropTypes.number).isRequired,
  fetchFilterResults: PropTypes.func.isRequired
}

export default withStyles(styles)(PublicationDrugTopicsCard)
